import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    maxWidth: theme.spacing(267),
    padding: theme.spacing(20.5, 30.5, 21.25, 18),
  },
  title: {
    color: theme.palette.grey['A200'],
    fontWeight: 500,
    lineHeight: '25px',
    fontSize: theme.spacing(9),
  },
  balancesWrapper: {
    overflowY: 'auto',
  },
}));
